import { useState } from "react";
import "./collapsed-box.css";

import { ReactComponent as IconChevronsUp } from "../../assets/svg/chevrons-up.svg";
import { ReactComponent as IconArrowLeft } from "../../assets/svg/arrow-left.svg";
import { Box, IconButton, Typography } from "@mui/material";
import { RUNNER_STATUS } from "../../constants/global.constants";
import { TutorialPopupResult } from "../tutorials/tutorial-popup-result";
import { ViewOnlyMsg } from "../layout/view-only-msg";
import { useResultsContext } from "../../services/context/results-context";

export const CollapsedSidebar = ({
  title,
  displayBackBtn,
  status = null,
  setSelectedRunner,
  left = true,
  children,
  displayTutorialBtn = false,
  viewOnly = false,
  surveyData = null,
}) => {
  const { isSidebarCollapsed, setIsSidebarCollapsed } = useResultsContext();
  const [toggleCollapse, setToggleCollapse] = useState(false);

  const isCollapsed = surveyData
    ? left
      ? isSidebarCollapsed.left
      : isSidebarCollapsed.right
    : toggleCollapse;

  const handleToggleCollapse = () => {
    if (surveyData) {
      const sidebarSide = left ? "left" : "right";
      setIsSidebarCollapsed((prev) => ({
        ...prev,
        [sidebarSide]: !prev[sidebarSide],
      }));
    } else {
      setToggleCollapse((prev) => !prev);
    }
  };

  return (
    <Box
      sx={{
        width: surveyData ? "240px" : "320px",
        minHeight: "60px",
        height: isCollapsed ? "60px" : "calc(100% - 80px - 74px)",
        /* minHeight: isCollapsed ? "0" : "0", */
        overflow: isCollapsed ? "hidden" : "visible",
        transition: "all 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        background: "#FBFBFD",
        borderRadius: "16px",
        position: "absolute",
        top: "80px",
        left: left ? "16px" : null,
        right: left ? null : "16px",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        boxShadow: 3,
      }}
    >
      {viewOnly && <ViewOnlyMsg />}
      <Box
        sx={{
          minHeight: "60px",
          height: "60px",
          padding: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          {displayBackBtn && (
            <IconButton onClick={() => setSelectedRunner(null)}>
              <IconArrowLeft
                stroke="#5d5f6a"
                /*  strokeWidth={"2px"} */
                width={"18px"}
                height={"18px"}
              />
            </IconButton>
          )}

          {surveyData ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Typography
                variant="body1"
                fontWeight={600}
                noWrap
                lineHeight={1.2}
              >
                {surveyData.resultName}
              </Typography>
              <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  noWrap
                  lineHeight={1.2}
                >
                  {surveyData.runnerName}
                </Typography>
              </Box>
            </Box>
          ) : displayTutorialBtn ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <Typography fontSize={16} fontWeight={600}>
                {title}
              </Typography>
              <TutorialPopupResult />
            </Box>
          ) : (
            <Typography fontSize={16} fontWeight={600}>
              {title}
            </Typography>
          )}

          {status && (
            <Box
              sx={{
                width: "14px",
                height: "14px",
                background:
                  status === RUNNER_STATUS.FAILED
                    ? "#BA1A1A"
                    : status === RUNNER_STATUS.SUCCESS
                      ? "#0FC23C"
                      : "#F2B54B",
                borderRadius: "50%",
                ml: "2px",
                border: "2px solid #fff",
                boxShadow:
                  "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
              }}
            />
          )}
        </Box>
        <IconButton onClick={handleToggleCollapse}>
          <IconChevronsUp
            stroke="#5d5f6a"
            width={"18px"}
            height={"18px"}
            style={{
              rotate: isCollapsed ? "180deg" : "0deg",
              transition: "all 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            }}
          />
        </IconButton>
      </Box>
      {children}
    </Box>
  );
};
